// Module
var code = "<ng-form> <kform-builder-option property=\"validate.card\" type=\"text\" label=\"Cardinality\" placeholder=\"Cardinality\" title=\"The 'cardinality' value must be x-y (x = number, y = number > x or N for infinite).\\nEg: 1-N, 0-2, 1-3...\"></kform-builder-option> </ng-form> ";
// Exports
export default code;